/** Para onde o card de um destaque leva: uma página do portal ou um endereço externo. */
export type LinkDestaque = { interno: true; caminho: string } | { interno: false; url: string };

export const TIPO_LINK_EXTERNO = 'link-externo';

const PREFIXO_CATEGORIA = 'categoria/';

/**
 * As chaves do catálogo de destinos do adm que têm página no portal. O catálogo do adm é de
 * exemplo e não muda (decisão da usuária de 26/10/2026): a chave que não está aqui — IPTU,
 * nota fiscal, comunicados... — não tem página, e o card não aparece. As cinco últimas são as
 * dos destaques fixos semeados, que não estão no catálogo.
 *
 * O adm tem uma cópia (`PAGINA_PORTAL_POR_DESTINO`) para a prévia: mudar um lado exige mudar
 * o outro.
 */
export const PAGINA_POR_DESTINO: Readonly<Record<string, string>> = {
  'servicos/todos': '/servicos',
  'cartas-servico/todas': '/servicos',
  'servicos/agendamento': '/area-cidadao?aba=agendamento',
  'solicitacoes/acompanhar': '/acompanhamento',
  'ouvidoria/manifestacao': '/ouvidoria',
  'ouvidoria/esic': '/sic',
  'servicos-digitais/portal': '/servicos-digitais',
  'noticias/ultimas': '/noticias',
  'politica-atendimento': '/politica-atendimento',
  'outros-canais-atendimento': '/outros-canais-atendimento',
  lgpd: '/lgpd',
  'perguntas-frequentes': '/perguntas-frequentes',
  sic: '/sic',
};

/** Se o destino aponta para uma categoria — e então depende das categorias publicadas. */
export function ehDestinoDeCategoria(destino: string | null | undefined): boolean {
  return (destino ?? '').trim().startsWith(PREFIXO_CATEGORIA);
}

/**
 * Traduz o destino gravado no adm para o portal, ou `null` quando não há página.
 *
 * A categoria só vale se houver categoria publicada com o mesmo slug: em `/servicos/:categoria`,
 * um slug desconhecido cai na primeira categoria com serviço, e o card "Saúde" levaria a outra.
 */
export function linkDoDestaque(
  tipo: string | null | undefined,
  destino: string | null | undefined,
  slugsDeCategoria: ReadonlySet<string>
): LinkDestaque | null {
  const limpo = (destino ?? '').trim();

  if (!limpo) return null;

  if (tipo === TIPO_LINK_EXTERNO) {
    return /^https?:\/\//i.test(limpo) ? { interno: false, url: limpo } : null;
  }

  if (limpo.startsWith(PREFIXO_CATEGORIA)) {
    const slug = limpo.slice(PREFIXO_CATEGORIA.length);

    return slugsDeCategoria.has(slug) ? { interno: true, caminho: `/servicos/${slug}` } : null;
  }

  const caminho = Object.hasOwn(PAGINA_POR_DESTINO, limpo) ? PAGINA_POR_DESTINO[limpo] : null;

  return caminho ? { interno: true, caminho } : null;
}
